import { render, staticRenderFns } from "./BoxVideos.vue?vue&type=template&id=7ee68594&scoped=true&lang=pug"
import script from "./BoxVideos.vue?vue&type=script&lang=js"
export * from "./BoxVideos.vue?vue&type=script&lang=js"
import style0 from "./BoxVideos.styl?vue&type=style&index=0&id=7ee68594&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ee68594",
  null
  
)

export default component.exports